import dayjs from 'dayjs'

import { toLocaleString4 } from '@helper/grid/strings'
import { parseCurrency } from '@helper/parseCurrency'

import { displayDateBrazilian } from '../../util/standardizedDate'

const formattedDate = (date: string) => {
  return displayDateBrazilian(date)
}

const formattedValue = (date: number) => {
  return date.toFixed(2).replace('.', ',')
}
export const parseRuptureKpiDataModal = (data: any[]): any[] => {
  return data?.length === 0
    ? []
    : data.map(item => {
        return {
          'periodo-data': dayjs(item.periodo).format('DD/MM/YYYY'),
          'data-execucao-id': item.periodo ? formattedDate(item.periodo) : 0,

          'cd-loja-codigo-id': item.lojaId ? item.lojaId : 0,
          'cd-loja-nome-id': item.lojaDescricao ? item.lojaDescricao : '',

          'gerente-categoria-id': item.gerenteCategoriaDescricao
            ? item.gerenteCategoriaDescricao
            : '',
          'gerente-produto-id': item.gerenteProdutoDescricao
            ? item.gerenteProdutoDescricao
            : '',

          'produto-codigo-id': item.produtoId ? item.produtoId : 0,
          'produto-material-id': item.produtoDescricao
            ? item.produtoDescricao
            : '',

          'mundo-nome-id': item.mundoDescricao ? item.mundoDescricao : '',

          'categiria-compacta-nome-id': item.categoriaCompactaDescricao
            ? item.categoriaCompactaDescricao
            : '',

          'categiria-nome-id': item.categoriaDescricao
            ? item.categoriaDescricao
            : '',

          'status-nome-id': item.statusDescricao ? item.statusDescricao : '',

          'curva-abc-nome-id': item.curvaABCDescricao
            ? item.curvaABCDescricao
            : '',

          'empresa-codigo-id': item.empresaId ? item.empresaId : 0,
          'empresa-nome-id': item.empresaDescricao ? item.empresaDescricao : '',

          'fornecedor-codigo-id': item.fornecedorId ? item.fornecedorId : 0,
          'fornecedor-nome-id': item.fornecedorDescricao
            ? item.fornecedorDescricao
            : '',

          'ruptura-one-day-id': item.rupturaZeroDias
            ? parseCurrency({
                value: item.rupturaZeroDias,
                country: 'pt-br',
                minFraction: 0,
                maxFraction: 0
              })
            : 0,
          'ruptura-ten-days-id': parseCurrency({
            value: item.rupturaDezDias,
            country: 'pt-br',
            minFraction: 0,
            maxFraction: 0
          }),
          'ruptura-transito-id': item.estoqueOrdenado
            ? parseCurrency({
                value: item.estoqueOrdenado,
                country: 'pt-br',
                minFraction: 0,
                maxFraction: 0
              })
            : 0,
          'ruptura-dep-id': item.estoqueDep16
            ? parseCurrency({
                value: item.estoqueDep16,
                country: 'pt-br',
                minFraction: 0,
                maxFraction: 0
              })
            : 0,
          'ruptura-est-cd': item.estoqueCD
            ? parseCurrency({
                value: item.estoqueCD,
                country: 'pt-br',
                minFraction: 0,
                maxFraction: 0
              })
            : 0,
          'ruptura-disp-buffer': item.estoqueDisponivelBuffer
            ? parseCurrency({
                value: item.estoqueDisponivelBuffer,
                country: 'pt-br',
                minFraction: 0,
                maxFraction: 0
              })
            : 0,
          'curva-nome-id': item.curvaABCDescricao ? item.curvaABCDescricao : '',
          'ruptura-disponivel-id': item.estoqueDisponivel
            ? parseCurrency({
                value: item.estoqueDisponivel,
                country: 'pt-br',
                minFraction: 0,
                maxFraction: 0
              })
            : 0,
          'ruptura-dias-com-estoque':
            item.diasComEstoque > 999 ? 999 : item.diasComEstoque,
          'ruptura-ten-day-venda-media': item.retiraCentro4M
            ? toLocaleString4(item.retiraCentro4M)
            : 0,
          'ruptura-ten-day-custo': item.estoqueAvgInvCost
            ? formattedValue(item.estoqueAvgInvCost)
            : 0,
          'subcategoria-codigo-id': item.subCategoriaId
            ? item.subCategoriaId
            : 0,
          'subcategoria-nome-id': item.subCategoriaDescricao
            ? item.subCategoriaDescricao
            : '',
          'tipo-suprimento-id': item.tipoSuprimento ? item.tipoSuprimento : ''
        }
      })
}
